<template>
	<svg class="marcadagua" xmlns="http://www.w3.org/2000/svg">
		<defs>
			<pattern id="marcadagua" patternUnits="userSpaceOnUse" x="0" y="0" width="100" height="100">
				<text style="font: 20px/1 monospace" x="-422" y="428" transform="rotate(-45 -600 -250)">{{ login }}</text>
			</pattern>
		</defs>
		<rect fill="url(#marcadagua)" width="100%" height="100%"></rect>
	</svg>
</template>

<script>
export default {
	computed: {
		login() {
			return $sessao.getLogin()
		}
	}
}
</script>
